/**
 * Utility for getting the write direction in the browser which checks is the browser is Safari.
 */
export default class SafariWriteDirectionUtility {
	/**
	 * Gets write direction.
	 *
	 * @returns Write direction.
	 * @param element Html element.
	 */
	public static getWriteDirection(element: Element): string | null {
		if (navigator.userAgent.search('Safari') >= 0 && navigator.userAgent.search('Chrome') < 0) {
			return document.defaultView?.getComputedStyle(element, null).direction || 'ltr';
		}
		return null;
	}
}
